/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.1
 */

import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { API_HOSTNAME, WIDGET_API, WIDGET_ORDER_INQUIRIES_INQUIRIES, WIDGET_ORDER_INQUIRIES_ORDERS } from '../../../../../modules/app/Api';
import { makeSelectLocalStorageSelectedAccount } from '../../../../../modules/storage/storageSelectors';
import { requestSaga } from '../../../../../sagas/requestSaga';
import { widgetInquiriesFail, widgetInquiriesSuccess, widgetOrderFail, widgetOrderSuccess } from './widgetOrderInquiriesAction';

export function* loadOrdersListSaga(): SagaIterator {
    const URL = `${API_HOSTNAME}${WIDGET_API}${WIDGET_ORDER_INQUIRIES_ORDERS}`;
    try {
        const response = yield call(requestSaga, URL, 'GET');
        yield put(widgetOrderSuccess(response.orders));
    } catch (e: any) {
        yield put(widgetOrderFail(e));
    }
}

export function* loadInquiriesListSaga(): SagaIterator {
    const selectedAccount = (yield select(makeSelectLocalStorageSelectedAccount())).id;
    const URL = `${API_HOSTNAME}${WIDGET_API}${WIDGET_ORDER_INQUIRIES_INQUIRIES}/${selectedAccount}`;
    try {
        const response = yield call(requestSaga, URL, 'GET');
        yield put(widgetInquiriesSuccess(response.inquiries));
    } catch (e: any) {
        yield put(widgetInquiriesFail(e));
    }
}
